import { LazyMdaDemo } from '../LazyMdaDemo';
import {
  getArticleHeroMediaClassName,
  getArticleHeroMediaScale,
  resolveArticleHeroMedia,
  type ArticleHeroMedia,
} from '../../../../shared/domain/articleHeroMedia';
import { ArticleHeroMediaImage } from './ArticleHeroMediaImage';
import { ArticleHeroMediaVideo } from './ArticleHeroMediaVideo';

interface ArticleHeroMediaProps {
  heroMedia: ArticleHeroMedia | null | undefined;
  legacyMiniDemoId?: string | null;
  demoFallbackClassName?: string;
}

export function ArticleHeroMedia({
  heroMedia,
  legacyMiniDemoId,
  demoFallbackClassName = 'h-100 w-full rounded-card',
}: ArticleHeroMediaProps) {
  const resolved = heroMedia ?? resolveArticleHeroMedia({ mini_demo_id: legacyMiniDemoId });
  if (!resolved || resolved.kind === 'none') {
    return null;
  }

  const className = getArticleHeroMediaClassName(
    resolved.size,
    resolved.align,
    resolved.verticalAlign,
  );
  const scale = getArticleHeroMediaScale(resolved.size);

  if (resolved.kind === 'demo' && resolved.demoId) {
    return (
      <div className={className}>
        <div className="article-hero-media__demo overflow-hidden rounded-card bg-surface-frost-05">
          <LazyMdaDemo demoId={resolved.demoId} fallbackClassName={demoFallbackClassName} />
        </div>
      </div>
    );
  }

  if (resolved.kind === 'image' && resolved.url) {
    return (
      <div className={className}>
        <ArticleHeroMediaImage
          url={resolved.url}
          size={resolved.size}
          align={resolved.align}
          verticalAlign={resolved.verticalAlign}
          scale={scale}
        />
      </div>
    );
  }

  if (resolved.kind === 'video' && resolved.url) {
    return (
      <div className={className}>
        <ArticleHeroMediaVideo
          url={resolved.url}
          posterUrl={resolved.posterUrl}
          size={resolved.size}
          align={resolved.align}
          verticalAlign={resolved.verticalAlign}
          scale={scale}
        />
      </div>
    );
  }

  return null;
}

export function articleHasHeroMedia(input: {
  hero_media?: unknown;
  mini_demo_id?: string | null;
}): boolean {
  return resolveArticleHeroMedia(input) !== null;
}
